import { Box, Button, Table } from '@factorialco/deprecated-design-system'

import { QuotePricingLineItem } from 'modules/finance/components/Quotes/utils'
import i18n from 'modules/core/lib/i18n'

import AddItemButton from './AddItemButton'
import ItemRowPhase from './ItemRowPhase'
import ItemRowProduct from './ItemRowProduct'

interface BodyProps {
  standaloneItems?: QuotePricingLineItem[]
  currency: string
  isDraftStatus: boolean
  isProductQuote: boolean
  isJobCatalogTreeEnabled: boolean
  onUpdateLineItem?: (itemId: number, updates: Partial<QuotePricingLineItem>) => void
  onAddLineItem?: (itemType: 'role' | 'simple' | 'phase', parentId?: number | null) => void
  onDeleteLineItem?: (itemId: number) => void
  legalEntityCountry: string | undefined
}

const Body = ({
  standaloneItems = [],
  currency,
  isDraftStatus,
  isProductQuote,
  isJobCatalogTreeEnabled,
  onUpdateLineItem,
  onAddLineItem,
  onDeleteLineItem,
  legalEntityCountry,
}: BodyProps) => {
  const generateItemList = (items: QuotePricingLineItem[]) => {
    if (isProductQuote) {
      return items
        .filter((item) => item.type === 'simple')
        .map((item) => (
          <ItemRowProduct
            key={item.id}
            item={item}
            legalEntityCountry={legalEntityCountry}
            currency={currency}
            isDraftStatus={isDraftStatus}
            onUpdate={(updates) => onUpdateLineItem?.(item.id, updates)}
            onDelete={() => onDeleteLineItem?.(item.id)}
          />
        ))
    } else {
      return items.map((item) => {
        if (item.type === 'phase') {
          return (
            <ItemRowPhase
              key={item.id}
              phase={item}
              currency={currency}
              isDraftStatus={isDraftStatus}
              isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
              legalEntityCountry={legalEntityCountry}
              onAddItem={(phaseId, itemType) => onAddLineItem?.(itemType, phaseId)}
              onDeletePhase={() => onDeleteLineItem?.(item.id)}
              onUpdatePhase={(updates) => onUpdateLineItem?.(item.id, updates)}
              onUpdateChild={(itemId, updates) => onUpdateLineItem?.(itemId, updates)}
              onDeleteChild={(itemId) => onDeleteLineItem?.(itemId)}
            />
          )
        }
      })
    }
  }
  return (
    <Table.Body>
      {generateItemList(standaloneItems)}
      {onAddLineItem && isProductQuote && isDraftStatus && (
        <Table.Row>
          <Table.Cell colSpan={2}>
            <Box flexDirection="row" justifyContent="flexStart">
              <AddItemButton
                isProductQuote={isProductQuote}
                onAddRole={() => onAddLineItem('role')}
                onAddProduct={() => onAddLineItem('simple')}
              />
            </Box>
          </Table.Cell>
          <Table.Cell colSpan={14} />
        </Table.Row>
      )}
      {!isProductQuote && onAddLineItem && isDraftStatus && (
        <Table.Row>
          <Table.Cell colSpan={2}>
            <Box flexDirection="row" justifyContent="flexStart">
              <Button type="secondary" iconName="add" onClick={() => onAddLineItem('phase')}>
                {i18n.t('finance.quotes.quote_phases_table.actions.add_phase')}
              </Button>
            </Box>
          </Table.Cell>
          <Table.Cell colSpan={14} />
        </Table.Row>
      )}
    </Table.Body>
  )
}

export default Body
